// UserList.tsx
import { Box } from '@mui/material';
import CustomNoRowsOverlay from '@/components/CustomNoRowsOverlay';
import AppDataGrid from '@/components/DataGrid/AppDataGrid';
import { UserListsSchema } from '@/zod_schemas';
import useGetUserColumns from '../Permissions/Grid/useGetUserColumns';

const customMessage = 'No users available'; // Example custom message

// Define a functional component to use as the overlay
const NoRowsOverlay = () => <CustomNoRowsOverlay message={customMessage} />;

interface UserListProps {
  page?: string;
  isLoading: boolean;
  data: UserListsSchema[];
  assignUserGroup?: (id: string) => void;
  removeUserGroup?: (id: string) => void;
  setAssignSelectedRowIds?: React.Dispatch<
    React.SetStateAction<(string | number)[]>
  >;
}
const UserList = ({
  page,
  data,
  isLoading,
  assignUserGroup,
  removeUserGroup,
  setAssignSelectedRowIds,
}: UserListProps) => {
  const columns = useGetUserColumns({ page, assignUserGroup, removeUserGroup });

  return (
    <Box sx={{ width: '100%' }}>
      <AppDataGrid
        rows={data}
        columns={columns}
        loading={isLoading}
        onRowSelectionModelChange={(ids) => {
          if (setAssignSelectedRowIds) {
            setAssignSelectedRowIds(ids);
          }
        }}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        checkboxSelection
        disableRowSelectionOnClick
        slots={{
          noRowsOverlay: NoRowsOverlay,
        }}
        sx={{ border: 0, borderRadius: 0, minHeight: 320 }}
      />
    </Box>
  );
};

export default UserList;
